import styled from 'styled-components';
import * as CSS from 'csstype';
import ArrowDownSvg from '../assets/hotels/review/arrowdown.svg';

const ArrowDownIcon = styled(ArrowDownSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '1.2rem'};
  height: ${props => props.height || '1.2rem'};
  fill: ${props => props.fill || props.theme.colors.goBrandBlue.base};
  margin: ${props => props.margin};
  cursor: pointer;
`;

export default ArrowDownIcon;
